import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { routePropDefault, routeProps } from './_constants';

const useRouteProp = () => {
  const { pathname } = useLocation();

  const [routeProp, setRouteProp] = useState(routePropDefault);

  useEffect(() => {
    setRouteProp(routeProps.find(({ url }) => pathname.match(url)) || routePropDefault);
  }, [pathname]);

  const result = { ...routePropDefault, ...routeProp };
  return result;
};

export default useRouteProp;
